
const m = window.require("embercom/lib/filters-to-text");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
